<template>
    <div>

        <div
            v-show="propertyTypeModel === 'property_type-' + constructions.id"
            class="row"
        >
            <div class="col-md-6">
                <div class="form-group">
                    <label for="construction" class="required">{{ $t("parameters.form.names.construction") }}</label>
                    <select class="custom-select" id="construction" name="construction" v-model="constructionModel"
                    >
                        <option
                            v-for="constructionValue in constructions.values"
                            :value="constructionValue.id"
                            :selected="constructionValue.id === oldConstruction"
                        >
                            {{ $t('parameters.form.constructions.' + constructionValue.id) }}

<!--                            {{ constructionValue.name }}-->
                        </option>
                    </select>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
export default {
    name: 'ReproductionConstruction',
    props: {
        propertyTypeModel: {
            type: String,
            required: true,
        },
        houseType: {
            type: String,
            required: false
        },
        oldConstruction: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            constructionModel: '',
            defaultConstructions: [
                {
                    id: 'apartment_house',
                    values: [
                        {
                            id: 'brick',
                            name: 'Cihlová',
                        },
                        {
                            id: 'monolithic_panel',
                            name: 'Panelová',
                        },
                        {
                            id: 'monolithic_bar',
                            name: 'Monolitická ',
                        },
                        {
                            id: 'not_specified',
                            name: 'Jiná',
                        },
                    ],
                },
                {
                    id: 'family_house',
                    values: [
                        {
                            id: 'brick',
                            name: 'Cihlová',
                        },
                        {
                            id: 'monolithic_bar',
                            name: 'Monolitická ',
                        },
                        {
                            id: 'prefabricated',
                            name: 'Montovaná',
                        },
                        {
                            id: 'wood',
                            name: 'Dřevěná',
                        },
                        {
                            id: 'not_specified',
                            name: 'Jiná',
                        },
                    ],
                },
                {
                    id: 'recreational',
                    values: [
                        {
                            id: 'brick',
                            name: 'Cihlová',
                        },
                        {
                            id: 'wood',
                            name: 'Dřevěná',
                        },
                        {
                            id: 'not_specified',
                            name: 'Jiná',
                        },
                    ],
                },
            ],
            constructions: null
        }
    },
    created() {
        this.setupConstructions();
    },
    watch: {
        'propertyTypeModel'() {
            this.setupConstructions();
            this.constructionModel = this.constructions.values[0].id;
        },
        'houseType'() {
            if (this.propertyTypeModel === 'property_type-apartment_house') {
                this.setupApartmentConstructions();
            }
        }
    },
    mounted() {
        if (this.oldConstruction !== '') {
            this.constructionModel = this.oldConstruction;
        }
    },
    methods: {
        isConstructionAvailable() {
            let currentConstructionObj = this.defaultConstructions.filter(type => {
                let propType = this.propertyTypeModel.replace('property_type-', '');
                return type.id === propType;
            });

            if (currentConstructionObj.length === 0) {
                return false;
            }

            let availableConstruction = currentConstructionObj[0].values.find(construction => {
                return construction.id === this.oldConstruction;
            });

            return availableConstruction !== undefined;
        },
        setupConstructions() {
            if (this.propertyTypeModel === 'property_type-apartment_house') {
                this.setupApartmentConstructions();
            }

            if (this.propertyTypeModel === 'property_type-family_house') {
                this.constructions = this.defaultConstructions[1];
            }

            if (this.propertyTypeModel === 'property_type-recreational') {
                this.constructions = this.defaultConstructions[2];
            }

            this.constructionModel = this.constructions.values[0].id;
        },
        setupApartmentConstructions() {
            this.constructions = this.setupPanelConstructions();

            if (this.houseType === 'house_type-unified_other') {
                this.constructions = this.setupOtherConstructions();
            }

            if (this.houseType === 'house_type-atypical') {
                this.constructions = this.setupAtypicalConstructions();
            }

            this.constructionModel = this.constructions.values[0].id;
        },
        setupPanelConstructions() {
            return {
                id: 'apartment_house',
                values: [
                    {
                        id: 'prefabricated',
                        name: 'Montovaná',
                    },
                    {
                        id: 'not_specified',
                        name: 'Jiná',
                    },
                ],
            };
        },
        setupOtherConstructions() {
            return {
                id: 'apartment_house',
                values: [
                    {
                        id: 'brick',
                        name: 'Cihlová',
                    },
                    {
                        id: 'prefabricated',
                        name: 'Montovaná',
                    },
                    {
                        id: 'monolithic_bar',
                        name: 'Monolitická ',
                    },
                    {
                        id: 'not_specified',
                        name: 'Jiná',
                    },
                ],
            };
        },
        setupAtypicalConstructions() {
            return {
                id: 'apartment_house',
                values: [
                    {
                        id: 'brick',
                        name: 'Cihlová',
                    },
                    {
                        id: 'monolithic_panel',
                        name: 'Panelová',
                    },
                    {
                        id: 'monolithic_bar',
                        name: 'Monolitická ',
                    },
                    {
                        id: 'not_specified',
                        name: 'Jiná',
                    },
                ],
            };
        }
    }
}
</script>
